import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import Layout from "../components/Layout/layout"
import SEO from "../components/seo"
import { navigate } from "gatsby"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import Ariane from "../components/Ariane/ariane"
import Deliberations from "../components/Deliberations/deliberations"
import { deliberationsContainer } from "../styles/deliberations.module.scss"

const DeliberationsPage = ({ arianeDisplayed }) => {
  const [deliberationsData, setDeliberationsData] = useState(null)
  const [content, setContent] = useState(null)
  const [allowed, setAllowed] = useState(false)
  const settings = useBuildData().site_settings

  useEffect(() => {
    if (!settings.display_deliberations) {
      navigate("/")
    }
    setAllowed(true)
    if (settings.content_deliberations) {
      setContent(settings.content_deliberations)
    }
    const urlDeliberations =
      process.env.GATSBYSIDE_DRUPAL_URL + "/api/deliberations/get"
    fetch(urlDeliberations)
      .then((response) => {
        return response.json()
      })
      .then((resultDeliberations) => {
        setDeliberationsData(resultDeliberations)
      })
  }, [])

  return (
    <>
      {allowed && (
        <Layout message="Actes">
          <SEO title="Actes" />
          {arianeDisplayed && <Ariane pageName="Actes" isListing={true} />}
          {deliberationsData && (
            <div className={deliberationsContainer}>
              {content && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: content.value,
                  }}
                />
              )}
              <Deliberations deliberationsData={deliberationsData} />
            </div>
          )}
        </Layout>
      )}
    </>
  )
}

DeliberationsPage.propTypes = {
  arianeDisplayed: PropTypes.bool,
}

export default DeliberationsPage
